var map = {
  "./pt.po": [
    "372",
    "549"
  ],
  "./es.po": [
    "5756",
    "389"
  ],
  "./en.po": [
    "7911",
    "996"
  ],
  "./da.po": [
    "4683",
    "488"
  ],
  "./fr.po": [
    "484",
    "813"
  ],
  "./it.po": [
    "5989",
    "382"
  ],
  "./de.po": [
    "4607",
    "868"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 4501;
module.exports = __rspack_async_context;
